import React from 'react';

import { FrontendToolsRegistry } from '@lumapps/agent-chat-frontend-tools/types';
import { RunAgentParameters } from '@lumapps/ai-ag-ui/ag-ui';
import { AiAgentInstance } from '@lumapps/ai-ag-ui/types';

import { RegisterToolFunction } from '../types';

export type AgentChatInstanceValue = {
    agentInstance?: AiAgentInstance;
    runAgentParameters?: RunAgentParameters;
};

export interface AgentChatContextValue {
    /**
     * Updates agentInstance stored in ref and notifies instance subscribers.
     */
    setAgentInstance: (instance: AiAgentInstance | undefined) => void;
    /**
     * Updates runAgentParameters stored in ref and notifies instance subscribers.
     */
    setRunAgentParameters: (params: RunAgentParameters | undefined) => void;
    /**
     * Subscribe to agent instance changes. Returns unsubscribe function.
     */
    subscribeInstance: (listener: () => void) => () => void;
    /**
     * Get the current agent instance and run parameters
     */
    getInstance: () => AgentChatInstanceValue;
    /**
     * Register a full FrontendTool definition. Returns unregister function.
     */
    registerTool: RegisterToolFunction;
    /**
     * Subscribe to tools registry changes. Returns unsubscribe function.
     */
    subscribeTool: (listener: () => void) => () => void;
    /**
     * Get the current tools registry
     */
    getTools: () => FrontendToolsRegistry;
}

const EMPTY_REGISTRY: FrontendToolsRegistry = new Map();
const EMPTY_INSTANCE: AgentChatInstanceValue = {};

export const AgentChatContext = React.createContext<AgentChatContextValue>({
    setAgentInstance: () => {},
    setRunAgentParameters: () => {},
    subscribeInstance: () => () => {},
    getInstance: () => EMPTY_INSTANCE,
    registerTool: () => () => {},
    subscribeTool: () => () => {},
    getTools: () => EMPTY_REGISTRY,
});
